<div class="container container-padding">
    <h1 class="page-header">{{'REGISTRY.LIST' | translate}}</h1>

    <div class="box box-white">
        <div class="box-header-gray">
            <div class="box-tabs">
                <mat-tab-group (selectedIndexChange)="indexChanged($event)"
                               [selectedIndex]="selectedIndex">
                    <mat-tab label="{{'REGISTRY.CONFIGRATIONS_OFFERS' | translate}}">
                        <div class="box-header-gray box-body box-body-sm mt-2">
                            <form (keydown)="onKeyDownOffers($event)">

                                <div class="row form-row mt-3">
                                    <div class="col-3">
                                        <app-input [label]="'NAME_SURNAME_COMPANY' | translate"
                                                   [ngModelOptions]="{standalone:true}"
                                                   [(ngModel)]="offerRequest.name">
                                        </app-input>
                                    </div>

                                    <div class="col-3">
                                        <app-numpad
                                                [ngModelOptions]="{standalone:true}"
                                                [(ngModel)]="offerRequest.pesel"
                                                [config]="{maxlength: 11, allowLeadingZeros: true}"
                                                [label]="'LABEL.PESEL' | translate">
                                        </app-numpad>
                                    </div>

                                    <div class="col-2">
                                        <app-select [(ngModel)]="offerRequest.status"
                                                    [ngModelOptions]="{standalone:true}"
                                                    [label]="'CALCULATION_TYPE' | translate"
                                                    [itemList]="(dictionaries$|async)[dictionaryTypes.OFFER_STATUS].itemList">
                                        </app-select>
                                    </div>

                                    <div class="col-2">
                                        <app-datepicker [label]="'LABEL.CREATION_DATE_FROM' | translate"
                                                        [max]="offerRequest.createdTo"
                                                        [(ngModel)]="offerRequest.createdFrom"
                                                        [ngModelOptions]="{standalone:true}">
                                        </app-datepicker>
                                    </div>

                                    <div class="col-2">
                                        <app-datepicker [label]="'LABEL.CREATION_DATE_TO' | translate"
                                                        [min]="offerRequest.createdFrom"
                                                        [(ngModel)]="offerRequest.createdTo"
                                                        [ngModelOptions]="{standalone:true}">
                                        </app-datepicker>
                                    </div>
                                </div>

                                <div class="row form-row">
                                    <div class="col-3">
                                        <app-input [label]="'OFFER_CALCULATION_NUMBER' | translate"
                                                   [(ngModel)]="offerRequest.number"
                                                   [ngModelOptions]="{standalone:true}">
                                        </app-input>
                                    </div>

                                    <div class="col-3">
                                        <app-input [label]="'BRANCH' | translate"
                                                   [(ngModel)]="offerRequest.branch"
                                                   [ngModelOptions]="{standalone:true}">
                                        </app-input>
                                    </div>

                                    <div class="col-3">
                                        <app-input [label]="'AGENCY' | translate"
                                                   [(ngModel)]="offerRequest.agency"
                                                   [ngModelOptions]="{standalone:true}">
                                        </app-input>
                                    </div>

                                    <div class="col-3">
                                        <app-input [label]="'OFWCA' | translate"
                                                   [(ngModel)]="offerRequest.seller"
                                                   [ngModelOptions]="{standalone:true}">
                                        </app-input>
                                    </div>
                                </div>

                                <div class="row mb-4">
                                    <div class="col"></div>
                                    <div class="col-auto">
                                        <button class="btn btn-link"
                                                (click)="csvOffers()"
                                                type="button">
                                            <i class="icon-download-2 mr-2"></i>
                                            <span>{{'BUTTON.EXPORT_CSV' | translate}}</span>
                                        </button>
                                        <button class="btn btn-primary btn-min-width"
                                                (click)="searchOffers()"
                                                type="button">{{'BUTTON.SEARCH' | translate}}</button>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <app-empty [iconClass]="'icon-search-big'"
                                   *ngIf="(offers$ | async) !== null && (offers$ | async).length === 0">
                            {{ 'OFFER.EMPTY' | translate }}
                        </app-empty>

                        <div class="box-content box-white box-body box-body-sm"
                             *ngIf="(offers$ | async) !== null && (offers$ | async).length > 0">
                            <table class="table table-lg">
                                <colgroup>
                                    <col width="30px">
                                    <col>
                                    <col>
                                    <col>
                                    <col>
                                    <col>
                                    <col *ngIf="hasSalesColumn.indexOf(user.entityRole) !== -1">
                                    <col width="30px">
                                </colgroup>
                                <thead>
                                <tr>
                                    <th></th>
                                    <th>{{'REGISTRY.INSURED' | translate}}</th>
                                    <th class="text-right">{{'REGISTRY.PREMIUM' | translate}}</th>
                                    <th>{{'REGISTRY.CALCULATION_TYPE' | translate}}</th>
                                    <th>{{'LABEL.CREATION_DATE' | translate}}</th>
                                    <th class="text-right">{{'REGISTRY.OFFER_NR_CALCULATION' | translate}}</th>
                                    <th *ngIf="entityRole.HEADQUATERS === user.entityRole || entityRole.SALES_MANAGER === user.entityRole">
                                        {{'REGISTRY.AGENT' | translate}} / {{'REGISTRY.OFWCA' | translate}}
                                    </th>
                                    <th *ngIf="entityRole.AGENT === user.entityRole">
                                        {{'REGISTRY.OFWCA' | translate}}
                                    </th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let offer of (offers$ | async)"
                                    class="table-row-action">
                                    <td [class.has-icon]="offer.motor || offer.property || offer.frontier"
                                        [class.text-accent]="offer.accent">
                                        <i [class.icon-home]="!offer.motor && offer.property"></i>
                                        <i [class.icon-oc-border]="offer.frontier && !offer.motor && !offer.property"></i>
                                        <i [class.icon-car]="offer.motor && !offer.property"></i>
                                        <i [class.icon-car-home]="offer.motor && offer.property"></i>
                                    </td>
                                    <td>{{ offer.policyholderName }}</td>
                                    <td class="text-right">{{ offer.premium | premium }}</td>
                                    <td>{{ offer.status?.description }}</td>
                                    <td>{{ offer.creationDate | lsnDate }}</td>
                                    <td class="text-right">{{ offer.number }}</td>
                                    <td *ngIf="entityRole.HEADQUATERS === user.entityRole || entityRole.SALES_MANAGER === user.entityRole">
                                        {{ offer.agencyInfo }}, {{ offer.sellerInfo }}
                                    </td>
                                    <td *ngIf="entityRole.AGENT === user.entityRole">
                                        {{ offer.sellerInfo }}
                                    </td>

                                    <td class="has-icon">
                                        <a class="btn btn-link"
                                           [routerLink]="offerLink(offer)">
                                            <i class="icon-arrow-right"></i>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div class="separator"></div>
                        </div>
                    </mat-tab>

                    <mat-tab label="{{'REGISTRY.POLICIES' | translate}}">
                        <div class="box-header-gray box-body box-body-sm">
                            <div class="row form-row mt-2">
                                <div class="col-4">
                                    <app-input [label]="'NAME_SURNAME_COMPANY' | translate"
                                               [(ngModel)]="policyRequest.name"></app-input>
                                </div>

                                <div class="col-2">
                                    <app-numpad
                                            [(ngModel)]="policyRequest.pesel"
                                            [config]="{maxlength: 11, allowLeadingZeros: true}"
                                            [label]="'LABEL.PESEL' | translate">
                                    </app-numpad>

                                </div>

                                <div class="col-2">
                                    <app-input [label]="'REGISTRY.POLICY_NUMBER' | translate"
                                               [(ngModel)]="policyRequest.number"></app-input>
                                </div>

                                <div class="col-2">
                                    <app-datepicker [label]="'LABEL.CREATION_DATE_FROM' | translate"
                                                    [max]="policyRequest.issuanceDateTo"
                                                    [(ngModel)]="policyRequest.issuanceDateFrom">
                                    </app-datepicker>
                                </div>

                                <div class="col-2">
                                    <app-datepicker [label]="'LABEL.CREATION_DATE_TO' | translate"
                                                    [min]="policyRequest.issuanceDateFrom"
                                                    [(ngModel)]="policyRequest.issuanceDateTo">
                                    </app-datepicker>
                                </div>
                            </div>

                            <div class="row form-row">


                                <div class="col-2">
                                    <app-input [label]="'AGENCY' | translate"
                                               [(ngModel)]="policyRequest.agency">
                                    </app-input>
                                </div>

                                <div class="col-2">
                                    <app-input [label]="'OFWCA' | translate"
                                               [(ngModel)]="policyRequest.seller">
                                    </app-input>
                                </div>

                                <div class="col-2">
                                    <app-input [label]="'MOTOR_CONFIG.REGISTRATION_NUMBER' | translate"
                                               [(ngModel)]="policyRequest.licensePlate">
                                    </app-input>
                                </div>

                                <div class="col-2">
                                    <app-input [label]="'MOTOR_CONFIG.VIN' | translate"
                                               [(ngModel)]="policyRequest.vin">
                                    </app-input>
                                </div>

                                <div class="col-2">
                                    <app-datepicker [label]="'REGISTRY.INSURANCE_FROM' | translate"
                                                    [max]="policyRequest.insurancePeriodTo"
                                                    [(ngModel)]="policyRequest.insurancePeriodFrom">
                                    </app-datepicker>
                                </div>

                                <div class="col-2">
                                    <app-datepicker [label]="'REGISTRY.INSURANCE_TO' | translate"
                                                    [min]="policyRequest.insurancePeriodFrom"
                                                    [(ngModel)]="policyRequest.insurancePeriodTo">
                                    </app-datepicker>
                                </div>
                            </div>

                            <div class="row mb-4">
                                <div class="col"></div>
                                <div class="col-auto">
                                    <button class="btn btn-link"
                                            (click)="csvPolicies()"
                                            type="button">
                                        <i class="icon-download-2 mr-2"></i>
                                        <span>{{'BUTTON.EXPORT_CSV' | translate}}</span>
                                    </button>
                                    <button class="btn btn-primary btn-min-width"
                                            (click)="searchPolicies()"
                                            type="button">{{'BUTTON.SEARCH' | translate}}</button>
                                </div>
                            </div>
                        </div>

                        <app-empty [iconClass]="'icon-search-big'"
                                   *ngIf="(policies$ | async) !== null && (policies$ | async).length === 0">
                            {{ 'POLICY.EMPTY' | translate }}
                        </app-empty>

                        <div class="box-content box-white box-body box-body-sm"
                             *ngIf="(policies$ | async) !== null && (policies$ | async).length > 0">
                            <table class="table table-lg">
                                <colgroup>
                                    <col width="30px">
                                    <col>
                                    <col>
                                    <col>
                                    <col width="120px">
                                    <col>
                                    <col *ngIf="hasSalesColumn.indexOf(user.entityRole) !== -1" width="240px;">
                                    <col width="30px">
                                </colgroup>
                                <thead>
                                <tr>
                                    <th></th>
                                    <th>{{'LABEL.CREATION_DATE' | translate}}</th>
                                    <th>{{'REGISTRY.INSURED' | translate}}</th>
                                    <th class="text-right">{{'REGISTRY.PREMIUM' | translate}}</th>
                                    <th>{{'REGISTRY.INSURANCE_PERIOD' | translate}}</th>
                                    <th>{{'REGISTRY.OFFER_NR_CALCULATION' | translate}}</th>
                                    <th *ngIf="entityRole.HEADQUATERS === user.entityRole || entityRole.SALES_MANAGER === user.entityRole">
                                        {{'REGISTRY.AGENT' | translate}} / {{'REGISTRY.OFWCA' | translate}}
                                    </th>
                                    <th *ngIf="entityRole.AGENT === user.entityRole">
                                        {{'REGISTRY.OFWCA' | translate}}
                                    </th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let policy of (policies$ | async)"
                                    class="table-row-action">
                                    <td class="has-icon">
                                        <i [class.icon-home]="policy.type === configurationType.PROPERTY"></i>
                                        <i [class.icon-car]="policy.type === configurationType.MOTOR"></i>
                                        <i [class.icon-oc-border]="policy.type === configurationType.FRONTIER"></i>
                                    </td>

                                    <td>
                                        {{ policy.issueDate | lsnDate : 'yyyy-MM-dd HH:mm' }}
                                        <ng-container *ngIf="policy.ioffer">
                                            <br/> {{ 'REGISTRY.IOFFER' | translate }}
                                        </ng-container>

                                    </td>
                                    <td>{{ policy.policyholderName }}</td>
                                    <td class="text-right">{{ policy.premium | premium }}</td>
                                    <td>{{ policy.insuranceStart | lsnDate }} - {{ policy.insuranceEnd | lsnDate }}</td>
                                    <td>{{ policy.number }}</td>
                                    <td *ngIf="entityRole.HEADQUATERS === user.entityRole || entityRole.SALES_MANAGER === user.entityRole">
                                        {{ policy.agencyInfo }}, {{ policy.sellerInfo }}
                                    </td>
                                    <td *ngIf="entityRole.AGENT === user.entityRole">
                                        {{ policy.sellerInfo }}
                                    </td>
                                    <td class="has-icon">
                                        <a class="btn btn-link"
                                           [routerLink]="['/policy', policy.offerId]">
                                            <i class="icon-arrow-right"></i>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div class="separator"></div>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
</div>
